<template>
  <div class="auth-wrapper auth-v1 px-2">
    <b-modal
      id="modal-scrollable"
      scrollable
      title="使用條款（包括有關私隱政策，免責聲明及版權的條款）"
      size="lg"
      ok-title="關閉"
      ok-only
    >
        <div v-html="client.html_tnc"></div>
       
      
    </b-modal>
    <div class="auth-inner py-2">

      <!-- Register v1 -->
      <b-card class="mb-0">
        <div class="text-center">
            <b-img thumbnail :src='client.logo' fluid />
          <b-link class="brand-logo">
            
            <h2 class="brand-text">
                {{ client.client_name }}
            </h2>
          </b-link>
        </div>

        <b-card-title class="mb-1">
          新學員登記表格
        </b-card-title>
        <b-card-text class="mb-2">

        </b-card-text>

        <!-- form -->
        <validation-observer ref="registerForm">
          <h4 class="brand-text text-primary ml-1" v-if="valid === false">Invalid Link</h4>
          <b-form v-if="insert === false && valid === true">
            <b-form-group
              label="中文姓名 Chinese Name*"
              label-for="zh_name"
            >
              <b-form-input
                id="zh_name"
                :readonly="readonly"
                autocomplete="off"
                v-model="student.zh_name"
                trim
              />

            </b-form-group>

             <b-form-group
               label="英文姓名 English Name *"
               label-for="card"
             >
               <b-form-input
                 id="card"
                 style="text-transform: uppercase;"
                 v-model="student.en_name"
                 :readonly="readonly"
                 autocomplete="off"
                 trim
               />

             </b-form-group>
             <b-form-group
               label="就讀學校 Studying School *"
               label-for="school"
             >
               <v-select
                 id="school"
                 :clearable="false"
                 @search="fetchOptions"
                :filterable="false"
                 :options="schoolOptions"
                 :reduce="g => g.id"
                 v-model="student.school"
                 trim
               />


             </b-form-group>
             <b-form-group
               label="在學級別 *"
               label-for="scholl_grade"
             >
               <v-select
                 id="scholl_grade"
                 :clearable="false"
                 :options="schoolGradeOptions"
                 :disabled="readonly"
                 :reduce="g => g.value"
                 v-model="student.school_grade"
                 trim
               />


             </b-form-group>
           <b-form-group
             label="出生日期 Date of Birth (YYYY-MM-DD)"
             label-for="Expiry Date"
           >
             <b-form-input
               id="expire"
               v-mask="'####-##-##'"
               v-model="student.birth"
               autocomplete="off"
               trim
             />

           </b-form-group>

           <b-form-group
             label="地址 Address"
             label-for="address"
           >

             <b-form-textarea
             id="address"
             v-model="student.address"
             autocomplete="off"
             trim/>

           </b-form-group>
           <b-form-group
             label="主要聯絡電話 Contact Mobile"
             label-for="mobile"
           >
             <b-form-input
               id="mobile"
               v-model="student.mobile"
               :readonly="readonly"
               autocomplete="off"
               trim
             />

           </b-form-group>

           <b-form-group
             label="性別 Gender"
             label-for="gender"
           >
             <v-select
               id="gender"
               :clearable="false"
               :disabled="readonly"
               :options="genderOptions"
               :reduce="g => g.value"
               v-model="student.gender"
               trim
             />

           </b-form-group>
           <hr class="my-3"/>
            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="register-privacy-policy"
                v-model="student.status"
                name="checkbox-1"
              >
                我已閱讀及同意<b-link v-b-modal.modal-scrollable>使用條款（包括有關私隱政策，免責聲明及版權的條款）</b-link>

              </b-form-checkbox>
            </b-form-group>
            <VueSignaturePad ref="signaturePad" height="150px" :options="{ dotSize: 2, throttle: 16,backgroundColor: 'rgba(200,200,200,1)',onBegin, onEnd }"/>
            <b-button v-ripple.400="'rgba(255, 159, 67, 0.15)'" class="mt-1" block @click="clear()" variant="outline-warning">
                清除簽名
            </b-button>
            <!-- submit button -->
            <hr class="my-2"/>
            <b-button
              variant="primary"
              block

              type="button"
              @click="submit"
            >
              送出 Submit
            </b-button>
          </b-form>
        </validation-observer>




      </b-card>
    <!-- /Register v1 -->
    </div>
  </div>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BLink, BCardTitle, BCardText, BForm,BImg,
  BButton, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BFormCheckbox,BFormTextarea
} from 'bootstrap-vue'
import router from '@/router'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import Nl2br from 'vue-nl2br'
import VueSignaturePad from 'vue-signature-pad'
import { readonly } from 'vue'
export default {
  components: {
    VuexyLogo,
    // BSV
    BCard,
    Nl2br,
    BLink,
    BCardTitle,
    router,
    BCardText,
    BFormTextarea,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BImg,
    vSelect,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      regEmail: '',
      username: '',
      valid : true,
      password: '',
      status: false,
      insert: false,
      schoolOptions: [],
      genderOptions:[
        { label:'男 Male',value:'M'},
        { label:'女 Female',value:'F'}
      ],
      schoolGradeOptions: [
        { label: 'M', value: 'M' },
        { label: 'K1', value: 'K1' },
        { label: 'K2', value: 'K2' },
        { label: 'K3', value: 'K3' },
        { label: 'P1', value: 'P1' },
        { label: 'P2', value: 'P2' },
        { label: 'P3', value: 'P3' },
        { label: 'P4', value: 'P4' },
        { label: 'P5', value: 'P5' },
        { label: 'P6', value: 'P6' },
        { label: 'S1', value: 'S1' },
        { label: 'S2', value: 'S2' },
        { label: 'S3', value: 'S3' },
        { label: 'S4', value: 'S4' },
        { label: 'S5', value: 'S5' },
        { label: 'S6', value: 'S6' },
      ],
      scrollContent: [],
      client:null,
      readonly : false,
      student : {
        zh_name: null,
        en_name: null,
        mobile: null,
        address:null,
        birth:null,
        gender:null,
        status:null,
        school_grade:null,
        student:null,
        initial:router.currentRoute.params.initial,
        student_uuid : null,
        center_code:router.currentRoute.params.center_code
      },
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  created() {
    if (this.$route.query.student != undefined) {
      this.student_uuid = "?student=" + this.$route.query.student
    }
    this.get_client_information()
    this.fetchOptions('')
    
  },
  methods: {
    clear() {
      this.$refs.signaturePad.clearSignature();
    },
    onBegin() {
      console.log('=== Begin ===');
    },
    onEnd() {
      console.log('=== End ===');
    },
    get_client_information() {
      this.$http.get( process.env.VUE_APP_API_BASE+'/client/' + router.currentRoute.params.initial +"/"+ this.student_uuid  )
        .then(res => {
          this.client = res.data.client
          if (res.data.student_result === true) {

            if (res.data.student.signed_at !== null) {
              this.$swal({
              title: '已簽署及同意條款',
              text: '',
              icon: 'success',
              showConfirmButton : false,
              buttonsStyling: false,
              backdrop: true,
              allowOutsideClick:false
            })
            }


            this.student = res.data.student
            this.readonly = true
            this.student.initial = router.currentRoute.params.initial
            this.student.center_code = router.currentRoute.params.center_code
          }
        })
    },
    fetchOptions (search, loading) {
      setTimeout(() => {
      this.$http.get(process.env.VUE_APP_API_BASE+'/schools/?string='+search)
            .then(res => {
              this.schoolOptions = res.data.schools
            })
            }, 200);
      },
    submit() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      this.student.signature = data

      this.$http.post(process.env.VUE_APP_API_BASE+'/student/register/', this.student)
        .then(res => {
          if (res.data.result === true) {
            this.$swal({
              title: '註冊成功!',
              text: res.data.message,
              icon: 'success',
              showConfirmButton : false,
              buttonsStyling: false,
              backdrop: true,
              allowOutsideClick:false
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.auth-wrapper.auth-v1 .auth-inner {
    max-width: 700px;
}
</style>
